
const fullLengths = [
    0, //undefined
    11, // US (1)
    13, //UK (2)
    11, //CA (3)
    12, //AU (4)
  ];
export const LinkTypes = {
    None:"",
    Page:"page",
    Url:"url",
    Scroll:"scroll",
    MultiPage:"multiPage", // exclusive for booking
    Email:"email",
    Phone:"phone",
    PromoCode:"promoCode",
    DailyDeal:"dailyDeal",
    Form:"form",
    Service:"service",
    Class:"class",
    Product:"Product",
    Package:"Package",
    Membership:"Membership",
    Dismiss:"dismiss"

}

export const LinkTypeSeperator = "|<linkType>|";
const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const urlValidation = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;

export const GetLinkAndType = (rawValue:string,defautlType:string = LinkTypes.Url)=>{

    const split = rawValue.split(LinkTypeSeperator);
    let returnObj = {link:split[0],type:defautlType};
    
    if(rawValue==="dismiss"){
        returnObj.type = LinkTypes.Dismiss;
        returnObj.link = "dismiss";
        return returnObj;
    }

    if(rawValue.startsWith("http://")||rawValue.startsWith("https://")){
        returnObj.type = LinkTypes.Url;
        
    }


    if(split.length>1){
        switch(split[1]){

            case LinkTypes.Page:
                returnObj.type = LinkTypes.Page;
                break;
            case LinkTypes.Scroll:
                returnObj.type = LinkTypes.Scroll;
                break;
            case LinkTypes.MultiPage:
                returnObj.type = LinkTypes.MultiPage;
                break;
            case LinkTypes.Email:
                returnObj.type = LinkTypes.Email;
                break;
            case LinkTypes.Phone:
                returnObj.type = LinkTypes.Phone;
                break;
            case LinkTypes.PromoCode:
                returnObj.type = LinkTypes.PromoCode;
                break;
            case LinkTypes.DailyDeal:
                returnObj.type = LinkTypes.DailyDeal;
                break;
           case LinkTypes.Form:
                    returnObj.type = LinkTypes.Form;
                    break;
            case LinkTypes.Service:
                returnObj.type = LinkTypes.Service;
                break;
            case LinkTypes.Class:
                returnObj.type = LinkTypes.Class;
                    break;
            case LinkTypes.Product:
                returnObj.type = LinkTypes.Product;
                break;
            case LinkTypes.Package:
                returnObj.type = LinkTypes.Package;
                break;
            case LinkTypes.Membership:
                returnObj.type = LinkTypes.Membership;
                break;
            default:
                break;
        }
    }


   

    return returnObj;
}

export function GetLinkValidation(rawValue:string,countryCode = 0):{valid:boolean,message:string,class:string}{

    let returnObject = {
        valid:true,
        message:"",
        class:""
    }

    if(rawValue==="dismiss"){
        return returnObject;
    }
    let lData = GetLinkAndType(rawValue);

    if(lData.link == ""){
        returnObject.message = "Missing Link";
        returnObject.valid = false;
        return returnObject;
    }

    switch(lData.type){
        case "page":
          if(lData.link==="none"){//only secondary button can be none
            
                returnObject.message = "No Page Selected";
                returnObject.valid = false;
          }
          break;
        case "url":
          if( !urlValidation.test(lData.link)){
            
                returnObject.message = "Invalid Url";
                returnObject.valid = false;
          }
          break;
        case "phone":
            if(countryCode>0){
                let length = fullLengths[countryCode];
                if(lData.link.length!==length){
                    returnObject.message = "Invalid Phone Number";
                    returnObject.valid =  false;
                }
            }
          break;
        case "email":
          if( !emailValidation.test(lData.link)){
                returnObject.message = "Invalid Email";
                returnObject.valid = false;
          }
          break;
        case LinkTypes.DailyDeal:
            break;
        case LinkTypes.PromoCode:
            break;
        case LinkTypes.MultiPage:
            break;
        case LinkTypes.Scroll:
            break;
        

        case "none":
          break;
        default:
          break;

      }

      return returnObject;

}